import { Week } from "PFApp/booking/parts/overview/context/use_calendar_days";
import { ZoomMode } from "PFApp/booking/types/zoom_mode";
import { Typography } from "PFComponents/typography";
import { useDateFormatter } from "PFCore/hooks/use_date_formatter";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { StickyItem } from "../../sticky_item";
import { Today } from "./today";
import css from "./week_item.module.scss";

const MIN_WEEK_WIDTH = 40;

type WeekItemProps = {
  week: Week;
  zoomMode: ZoomMode;
};

export const WeekItem = ({ week, zoomMode }: WeekItemProps): JSX.Element => {
  const { startDate, endDate, width, left, isoWeek } = week;

  const { utc } = useDateFormatter();
  const { t } = useTranslation("bookingModule");

  const label = useMemo(() => {
    if (zoomMode === ZoomMode.Small) {
      return `${t("calendar.weekCommencingSign")} ${utc(startDate).format("D MMM")}`;
    }
    if (zoomMode === ZoomMode.Tiny) {
      return `${t("calendar.weekSign")}${isoWeek}`;
    }
    return `${utc(startDate).format("D MMM")} - ${utc(endDate).format("D MMM")} (${t(
      "calendar.weekSign"
    )}${isoWeek})`;
  }, [zoomMode, isoWeek, startDate, endDate, t, utc]);

  const isToday = startDate <= new Date() && endDate >= new Date() && zoomMode !== ZoomMode.Full;

  const shouldDisplayLabel = width > MIN_WEEK_WIDTH;

  return (
    <div
      className={css.week}
      style={{
        width,
        left
      }}
    >
      {shouldDisplayLabel && (
        <StickyItem>
          <Typography variant="bodyRegular" tag="span">
            {label}
          </Typography>
        </StickyItem>
      )}
      {isToday && <Today />}
    </div>
  );
};
